/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Actor = zod
	.object({
		actor_id: zod.string().describe("External actor ID from the customer's system"),
		email: zod.string().optional().describe('Actor email'),
		environment_id: zod.string().describe('Environment ID'),
		id: zod.string().describe('Actor ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		kind: zod.enum(['human', 'agent']),
		metadata: zod.looseObject({}).describe('Actor metadata'),
		name: zod.string().optional().describe('Actor name'),
		organization_id: zod.string().describe('Organization ID'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('An actor involved in moderation cases');

export type Actor = zod.input<typeof Actor>;
export type ActorOutput = zod.output<typeof Actor>;
